import { Tabs } from "antd";
import styles from "./index.module.css";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../context";
import Issuse from "./issue";
import Statistics from "./statistics";
import PageHeader from "../../../components/PageHeader";

export default function Activity() {
  const { parkName } = useContext(UserContext);
  const [activeKey, setActiveKey] = useState(1);
  const { pathname } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const onChange = (key) => {
    navigate(`/${parkName}/activity/${key}`);
  };

  const items = [
    {
      key: "1",
      label: "活动发布",
      children: <Issuse />,
    },
    {
      key: "2",
      label: "数据统计",
      children: <Statistics />,
    },
  ];
  useEffect(() => {
    setActiveKey(id);
  }, [pathname, id]);
  return (
    <div className={styles.root}>
      <PageHeader title="活动管理" description="一键发布相关会议，活动。" />
      <Tabs
        destroyInactiveTabPane={true}
        activeKey={activeKey}
        items={items}
        onChange={onChange}
      />
    </div>
  );
}
